import { Component, Input, OnInit } from '@angular/core';
import { TenantConfService } from 'src/app/services/tenant-conf.service';
import { InitialDataService } from '../../../services/initialData.service';

@Component({
  selector: 'app-mall-section-header',
  templateUrl: './mall-section-header.component.html',
  styleUrls: ['./mall-section-header.component.scss'],
})
export class MallSectionHeaderComponent implements OnInit {
  @Input() section: string;
  @Input() image: any;

  language: string;
  publicName$: any;

  constructor(
    private tenantService: TenantConfService,
    private initialDataService: InitialDataService
  ) {
    this.language = this.tenantService.getLanguage();
    this.initialDataService.getInitialData(this.language);
    this.publicName$ = this.initialDataService.publicName$;
  }

  ngOnInit() {}

}
